export default "__VITE_ASSET__BVbHHYa6__"